import { Component, OnInit } from '@angular/core';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css']
})
export class LoginPageComponent implements OnInit {
  isAuth: boolean;

  constructor(
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
  }

  authWithGoogle(): void {
    this.authService
      .loginWithGoogle()
      .then(() => {
        if (this.authService.isAuthenticated()) {
          this.router.navigate(['/menu']);
        }
      })
      .catch((err) => console.log(err));
  }

  onSubmit(): void {
    // Ocultar el Formulario de Login
    document.getElementById('form-login').classList.add('animate__fadeOutDown');
    // Mostrar Loader (Componente)
    document.getElementById('loader').classList.remove('d-none');
    document.getElementById('loader').classList.remove('animate__fadeOutDown');
    document.getElementById('loader').classList.add('animate__fadeInDown');
    // Crear el Usuario
    const user = {
      email: (<HTMLInputElement>document.getElementById("Email")).value,
      password: (<HTMLInputElement>document.getElementById("Password")).value,
    };
    // Petición al Servicio AuthService
    this.authService
      .loginWithCredentials(user)
      .then(() => {
        setTimeout(() => {
          this.router.navigate(['/menu']);
        }, 3000);
      })
      .catch((err) => {
        console.log('error!', err);
        setTimeout(() => {
          // Enviar el Alerta
          this.toastr.info('Por favor, revise que este escribiendo correctamente todos los datos solicitados.');
          document.getElementById('loader').classList.remove('animate__fadeInDown');
          document.getElementById('loader').classList.add('animate__fadeOutDown');
          document.getElementById('loader').classList.add('d-none');
          document.getElementById('form-login').classList.remove('animate__fadeOutDown');
          document.getElementById('form-login').classList.add('animate__fadeInDown');
        }, 2000);
      });
  }

  resetPassword() {
    // Cerrando Modal
    (<HTMLInputElement>document.getElementById("CloseModal")).click();

    // Obtener el Email del Modal
    var email = (<HTMLInputElement>document.getElementById("resetPasswordEmail")).value;

    // Enviar al servicio ese Emial para su Reset
    this.authService.resetPassword(email);

    // Enviar el Alerta
    this.toastr.success('Se le ha enviado un correo para que recupere su contraseña.');

  }

  Login: AnimationOptions = {
    path: '/assets/img/login.json',
  };

  animationCreated(animationItem: AnimationItem): void {
    console.log(animationItem);
  }
}
